// extracted by mini-css-extract-plugin
export default {"buttonRow":"button-row_buttonRow__DS0va","centerAlign":"button-row_centerAlign__ULo6s"};